<template>
    <ModalTemplate :minimised="minimised" :visable="view != null" @close="close">
        <component
            :is="view"
            ref="view"
            :_options="_options"
            :editingModel="editingModel"
            :minimised="minimised"
            :modelId="modelId"
            :modelType="modelType"
            :options="options"
            @close="close"
            @minimise="minimise"
        />
    </ModalTemplate>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import Note from './elements/note.vue'
import Task from './elements/task.vue'
import Deal from './elements/deal.vue'
import DealDelete from './elements/deal-delete.vue'
import SMS from './elements/sms.vue'
import WhatsApp from './elements/whatsapp.vue'
import Email from './elements/email.vue'
import TaskView from './elements/task-view.vue'
import Invoice from './elements/invoice.vue'
import PaymentMethodEdit from './elements/payment-method-edit.vue'
import PaymentMethodCreate from './elements/payment-method-create.vue'
import SubscriptionCreate from './elements/subscription-create.vue'
import SubscriptionChangePlan from './elements/subscription-change-plan.vue'
import SubscriptionCancel from './elements/subscription-cancel.vue'
import SubscriptionReactivate from './elements/subscription-reactivate.vue'
import SubscriptionUpdatePaymentMethod from './elements/subscription-update-payment-method.vue'
import UserEdit from './elements/user-edit.vue'
import UserEditPassword from './elements/user-edit-password.vue'
import CalendarCreateEvent from './elements/calendar-create-event.vue'
import CalendarViewMore from './elements/calendar-view-more.vue'
import CustomerCallCreate from './elements/customer-call-create.vue'
import ActiveCall from './elements/active-call.vue'
import OnboardingViewUploadedImage from './elements/onboarding-view-uploaded-image.vue'
import ContactCreate from './elements/contact-create.vue'
import ContactDelete from './elements/contact-delete.vue'
import UploadDeleteFolder from './elements/upload-folder-delete.vue'
import ContactCommunications from './elements/contact-communications.vue'
import Upload from './elements/upload.vue'
import UploadEdit from './elements/upload-edit.vue'
import UploadDelete from './elements/upload-delete.vue'
import Confirm from './elements/confirm.vue'
import DefaultFolderCreate from './elements/default-folder-create.vue'
import LeadEdit from './elements/lead-edit.vue'
import LeadDelete from './elements/lead-delete.vue'
import LeadFlagged from './elements/lead-flagged.vue'
import LeadAddToContact from './elements/lead-add-to-contact.vue'
import Lost from './elements/lost.vue'
import PipelineStageEdit from './elements/pipeline-stage-edit.vue'
import PipelineStageDelete from './elements/pipeline-stage-delete.vue'
import CrmRefill from './elements/crm-refill.vue'
import CrmAutoRefill from './elements/crm-auto-refill.vue'
import CrmAutoRefillRemove from './elements/crm-auto-refill-remove.vue'
import CrmOutOfFunds from './elements/crm-out-of-funds.vue'
import SubscriptionMap from './elements/subscription-map-modal.vue'
import TableManageViews from './elements/table-manage-views.vue'
import TableCreateView from './elements/table-create-view.vue'

export default {
    mounted() {
        this.$event.$on('modal-open', (data) => {
            this.open(data)

            // this.close();

            // this.view = data.view;
            // this.modelId = data.modelId != undefined ? data.modelId : null;
            // this.modelType =
            // 	data.modelType != undefined ? data.modelType : null;
            // this.editingModel = shallowRef(
            // 	data.editingModel != undefined ? data.editingModel : null);
            // this.options = data.options != undefined ? data.options : null;
        })

        this.$event.$on('modal-set-options', (options) => {
            this._options = options
        })

        this.$event.$on('modal-update-options', (options) => {
            this.options = options
        })

        this.$event.$on('modal-close', () => {
            this.close()
        })
    },

    data() {
        return {
            view: null,
            modelId: null,
            modelType: null,
            editingModel: null,
            options: null,
            minimised: false,
            _options: null,
            lastModal: null,
            lastValue: null,
        }
    },

    methods: {
        open(data) {
            // console.log('modal-open', data)
            //
            // if (data.admin !== undefined && data.admin === true) {

            // }

            this.view = data.view
            this.options = data.options != undefined ? data.options : null
            this.editingModel = null
            this.modelId = data.modelId != undefined ? data.modelId : null
            this.modelType = data.modelType != undefined ? data.modelType : null
            this.lastModal = data.lastModal != undefined ? data.lastModal : null
            this.lastValue = data.currentValue != undefined ? data.currentValue : null

            if (data.editingModel) {
                this.editingModel = data.editingModel
            }
        },

        close() {
            this.view = null
            this.modelId = null
            this.modelType = null
            this.editingModel = null
            this.minimised = false

            console.log('lastModal', this.lastModal)

            if (this.lastModal != null) {
                this.$event.$emit('modal-open', this.lastModal)
            }

            // if (this.options.close != undefined) {
            //     this.options.close()
            // }
        },

        minimise() {
            this.minimised = !this.minimised
        },
    },

    computed: {
        user() {
            return this.$sanctumAuth.user()
        },

        action() {
            return this.view != null && this.$refs.view != null ? this.$refs.view.action : null
        },
    },

    components: {
        // Auto-load all components from ~/components/admin/modals/
        ...Object.fromEntries(
            Object.entries(
                import.meta.glob('~/components/admin/modals/*.vue', { eager: false })
            ).map(([path, loader]) => {
                // Extract the filename without extension and convert to PascalCase
                const name = path
                    .split('/')
                    .pop()
                    .replace(/\.vue$/, '')
                    .replace(/(^\w|-\w)/g, m => m.replace('-', '').toUpperCase());
                return [name, defineAsyncComponent(loader)];
            })
        ),
        // DomainBuy: defineAsyncComponent(() => import('./zapo/domain-buy.vue')),
        // LandingPageImageSelect: defineAsyncComponent(() => import('./zapo/landing-page-image-select.vue')),
        // LandingPageReviewEdit: defineAsyncComponent(() => import('./zapo/landing-page-review-edit.vue')),
        // LandingPageReviewImport: defineAsyncComponent(() => import('./zapo/landing-page-review-import.vue')),
        // LandingPageQuestionEdit: defineAsyncComponent(() => import('./zapo/landing-page-question-edit.vue')),
        // ProspectAddSubscription: defineAsyncComponent(() => import('./zapo/prospect-add-subscription.vue')),
        UserRoles: defineAsyncComponent(() => import('~/components/customer/modals/elements/user-roles.vue')),
        Confirm,
        Note,
        Task,
        Deal,
        DealDelete,
        SMS,
        WhatsApp,
        Email,
        Invoice,
        TaskView,
        PaymentMethodEdit,
        PaymentMethodCreate,
        SubscriptionCreate,
        SubscriptionChangePlan,
        SubscriptionUpdatePaymentMethod,
        SubscriptionCancel,
        SubscriptionReactivate,
        UserEdit,
        UserEditPassword,
        CalendarCreateEvent,
        CalendarViewMore,
        CustomerCallCreate,
        ActiveCall,
        OnboardingViewUploadedImage,
        ContactCreate,
        ContactDelete,
        ContactCommunications,
        Upload,
        UploadDeleteFolder,
        UploadEdit,
        UploadDelete,
        DefaultFolderCreate,
        LeadEdit,
        LeadDelete,
        LeadFlagged,
        LeadAddToContact,
        Lost,
        PipelineStageEdit,
        PipelineStageDelete,
        CrmRefill,
        CrmAutoRefill,
        CrmAutoRefillRemove,
        CrmOutOfFunds,
        SubscriptionMap,
        TableManageViews,
        TableCreateView
    },
}
</script>
